import SweetAlert from '../../../../vendor/SweetAlert';

const fileInput = document.getElementById('cv');
const showUploadedFileName = () => {
    document.getElementById('cv-filename').textContent = fileInput.value
        ? '( ' + fileInput.value.split('\\').pop() + ' )'
        : '';
};
fileInput.addEventListener('change', () => {
    showUploadedFileName();
    checkFileSize();
});

if (location.hash === '#cvTooBig') {
    SweetAlert.toastError('Le CV ne doit pas peser plus lourd que 10Mo.');
}

function checkFileSize() {
    const maxFileSizeInBytes = 1024 * 1024 * 10; // Example: 1 MB (adjust as needed)

    if (fileInput.files.length > 0 && fileInput.files[0].size > maxFileSizeInBytes) {
        SweetAlert.alertError('Le CV ne doit pas peser plus lourd que 10Mo.');
        fileInput.value = '';
        showUploadedFileName();
    }
}
